module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-session', {
    ref: "session"
  }), _vm._v(" "), _c('ed-socket', {
    ref: "socket"
  }), _vm._v(" "), _c('ed-notify', {
    ref: "notify"
  }), _vm._v(" "), _c('ed-dialog', {
    ref: "dialog"
  }), _vm._v(" "), _c('ed-loading', {
    ref: "loading"
  }), _vm._v(" "), _c('ed-request', {
    ref: "request"
  }), _vm._v(" "), (!_vm.loadingContent) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d88bffa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/index.vue
// module id = 1388
// module chunks = 44